import type { PropsWithChildren } from "react";

import { cn } from "../../utils";
import { useAlertRootContext } from "./context";
import { alertActionsStyle } from "./styles";

export type AlertActionsProps = PropsWithChildren<{ className?: string }>;

const Actions = ({ className, children }: AlertActionsProps) => {
  const { type } = useAlertRootContext();

  return <div className={cn(alertActionsStyle({ type }), "flex gap-3", className)}>{children}</div>;
};

export default Actions;
